import * as React from 'react';
import { Link } from 'react-router-dom';
import { HiExclamationCircle, HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { PaymentMethodManager } from 'src/registration/ui/components/payment-method-manager';
import { RegistrationActions } from 'src/registration/ui/components/registration-actions';
import { StatusChip } from 'src/shared/index';
import { LinkButton } from 'src/shared/ui/elements';
import { EventService } from 'src/event/service/event.service';

const EventAddress = ({ event }) => {
  const timeLimits = EventService.timeLabel(event);
  const dateLimits = EventService.dateLimits(event);

  const datesLabel = `${EventService.dateLabel(event)}${
    dateLimits ? ` (${dateLimits})` : ''
  }`;
  return (
    <div>
      <div className="fw-500">{event?.effectiveName || event?.label}</div>
      <div className="fw-500">{event?.program?.name}</div>
      <div>
        <div className="fs-12 fc-primary-30 mt-4">{event?.location?.name}</div>
        <div className="fs-10 fc-primary-30 mt-4">{datesLabel}</div>
        <div className="fs-10 fc-primary-30 mt-4">{timeLimits}</div>
      </div>
    </div>
  );
};

const YourProgramsMobile = ({
  $item: registration,
  $upcomingEventsMapByRegistrationId,
}) => {
  const { event } = registration;
  const upcomingEvents = $upcomingEventsMapByRegistrationId?.[registration.id];

  return (
    <li className="pa-16 shadow-2">
      <div className="flex align-center justify-space-between">
        <span className="fw-600">
          {registration.participant?.fullName || '-'}
        </span>
        <Link className="fc-accent" to={`/registrations/${registration.id}`}>
          {registration.id}
        </Link>
      </div>
      {registration.status === 'WITHDRAWN' && (
        <span className="fc-accent-50 block mt-10 fw-600">Withdrawn</span>
      )}
      {registration.status === 'PAUSED' && (
        <span className="fc-accent-50 block mt-10 fw-600">Paused</span>
      )}
      {registration.status === 'WAITLISTED' && (
        <StatusChip $level="warning">On Waitlist</StatusChip>
      )}

      <div className="my-16 pa-8 bg-primary-95 bc-primary-90 br-4 fc-primary-30">
        <EventAddress
          event={event}
          registrationEventName={registration.registrationEventName}
        />

        <div className="fw-500 mt-12">Guardians</div>
        <div className="flex wrap fs-13">
          {registration.guardians.length === 0 ? (
            <div className="tw-text-red">No guardians selected</div>
          ) : (
            registration.guardians.map((guardian, index) => {
              const inactive = guardian.type ? 'false' : 'true';
              return (
                <span
                  key={`${guardian.id}--${index}`}
                  className="mr-12 mc-r mt-4"
                >
                  <span data-inactive={inactive}>{guardian.fullName}</span>
                  <span
                    data-inactive={inactive}
                    className="css-element--pill bg-primary-45 ml-4"
                  >
                    {guardian.type ?? 'Inactive'}
                  </span>
                </span>
              );
            })
          )}
        </div>
      </div>

      <div>
        <PaymentMethodManager
          $registration={registration}
          $buttonClassName="outline mt-8 h-32 lh-30"
        />
      </div>
      <div className="mt-10">
        <RegistrationActions $registration={registration} />
      </div>

      {upcomingEvents?.length > 0 && (
        <div className="mt-16 pa-8 tw-bg-[#e6f7e6] tw-border-[#30cd92] tw-border tw-rounded-md">
          <div className="tw-flex tw-gap-2 tw-text-[#01c786] tw-text-sm tw-items-center tw-font-bold tw-mb-2">
            <HiExclamationCircle />
            <span>
              Sign {registration?.participant?.firstName} up for the next
              season!
            </span>
          </div>
          {upcomingEvents.map((item) => (
            <div
              key={item.id}
              className="tw-mb-2 tw-pb-2 tw-border-b tw-border-[#30cd92]"
            >
              <EventAddress
                event={item}
                registrationEventName={registration.registrationEventName}
              />
              <div className="tw-flex tw-justify-between tw-items-center tw-mt-2">
                <Link
                  className="tw-font-semibold tw-text-xs"
                  to={`/events/spotlight/${item.code}`}
                >
                  View Details
                </Link>
                <LinkButton
                  className="!tw-bg-[#03c786] !tw-border-[#30cd92] tw-max-w-28"
                  to={`/events/${item.code}`}
                >
                  <div className="tw-flex tw-items-center tw-gap-2 tw-justify-center">
                    <span>Enroll</span>
                    <HiOutlineArrowNarrowRight />
                  </div>
                </LinkButton>
              </div>
            </div>
          ))}
        </div>
      )}
    </li>
  );
};

export default YourProgramsMobile;
